<template>
  <dc-layout-main class="cos-full-layout">
    <div class="full-layout-content">
      <div class="left-layout bf" style="width: 50%">
        <div class="title">标签管理</div>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px; margin-top: 13px">
          <a-input v-model:value="inputValue" placeholder="输入名称查询标签" />
          <a-button style="margin-left: 13px" type="primary" @click="onSearch">查询</a-button>
          <a-button
            style="margin-left: 13px"
            v-permission="'lbu_label_add_top_btn'"
            type="primary"
            @click="triggerAddOrEdit()"
            >新增一级标签</a-button
          >
        </div>

        <cos-table
          bordered
          :serial="false"
          :dynamicColumnSetting="false"
          :needPage="false"
          :columns="columns"
          :expandedRowKeys="expandedKeys"
          @expand="onExpand"
          @fetch="fetch"
          ref="tableRef"
          tableId="lbuLabelManage"
          id="lbuLabelManage"
          rowKey="id"
        >
          <!-- <a-table :customRow="rowClick" :columns="columns" :data-source="allLabelList"> -->

          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'status'">
              <a-switch
                :checked="record.status"
                :checked-children="t('system.j8i04n')"
                :un-checked-children="t('system.426zce')"
                :checkedValue="0"
                :unCheckedValue="1"
                :key="record.name"
                v-on:click="onStatusClick($event, record)"
              />
            </template>
            <template v-if="column.dataIndex === 'name'">
              <a @click="rowClick(record)">
                <span v-if="record.name && record.name.indexOf(searchValue) > -1">
                  {{ record.name.substr(0, record.name.indexOf(searchValue)) }}
                  <span style="color: #f50">{{ searchValue }}</span>
                  {{ record.name.substr(record.name.indexOf(searchValue) + searchValue.length) }}
                </span>
                <span v-else>{{ record.name }}</span>
              </a>
            </template>
            <template v-if="column.dataIndex === 'labelType'">
              <p>{{ labelTypeEnum.find((v: any) => v.value == text)?.label }}</p>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <more-button>
                <a-button @click="onAdd(record)" v-permission="'lbu_label_add_btn'">
                  <template #icon>
                    <img style="margin-top: -4px; margin-left: 6px" src="@/assets/marketing/add-circle.svg" />
                  </template>
                </a-button>
                <a-button @click="triggerAddOrEdit(record)" v-permission="'lbu_label_edit_btn'">
                  <template #icon>
                    <img src="@/assets/marketing/edit.svg" />
                  </template>
                </a-button>
                <a-button @click="onDelete(record)" v-permission="'lbu_label_delete_btn'">
                  <template #icon>
                    <img src="@/assets/deleteIcon.svg" />
                  </template>
                </a-button>
              </more-button>
            </template>
          </template>
        </cos-table>
        <!-- </a-table> -->
      </div>

      <div class="right-layout bf">
        <div class="title">标签详情</div>
        <a-form :model="dataForm" ref="formRef" :wrapper-col="{ span: 30 }">
          <dc-form-item name="parentName" label="上级标签" :span="24">
            <a-input v-model:value="dataForm.parentName" :disabled="true" style="width: 100%" />
          </dc-form-item>
          <dc-form-item name="labelName" label="标签名称" :span="24">
            <CosInput v-model:value="dataForm.name" :disabled="true" style="width: 100%" />
          </dc-form-item>
          <dc-form-item label="类型" name="labelType" :disabled="true" :span="24">
            <CosSelect
              v-model:value="dataForm.labelType"
              :options="labelTypeEnum"
              placeholder="请选择"
              allowClear
              style="width: 100%"
              :disabled="true"
            />
          </dc-form-item>
          <a-form-item name="sort" label="顺序" :span="24">
            <a-input v-model:value="dataForm.weight" style="width: 100%" :disabled="true" />
          </a-form-item>
          <dc-form-item name="comment" label="备注" :span="24">
            <a-input v-model:value="dataForm.comment" style="width: 100%" :disabled="true" />
          </dc-form-item>
          <dc-form-item name="updateBy" label="操作人" :span="24">
            <a-input v-model:value="dataForm.updateBy" style="width: 100%" :disabled="true" />
          </dc-form-item>
          <dc-form-item name="updateTime" label="操作时间" :span="24">
            <a-input v-model:value="dataForm.updateTime" style="width: 100%" :disabled="true" />
          </dc-form-item>
        </a-form>
      </div>
    </div>
  </dc-layout-main>
  <LabelEditModal ref="labelModalRef" @fetch="handleQueryChange('fetch')" />
</template>
<script setup lang="ts">
import LabelEditModal from './LabelEditModal.vue'
import { ref, computed } from 'vue'
import { labelList, deleteLabel, updateLabel } from '@/api/yuntuSales/labelManage'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const tableRef = ref()
const searchValue = ref<string>('')
const inputValue = ref<string>('')
const expandedKeys = ref<any[]>([])
const dataForm = ref<any>({
  parentName: '--',
  name: '--',
  labelType: 0,
  weight: '--',
  comment: '--',
  updateBy: '--',
  updateTime: '--'
})

const rowClick = (record: any) => {
  record.parentName = getParentName(record.parentId, allLabelList.value)?.name ?? '--'
  dataForm.value = record
}

const onSearch = () => {
  searchValue.value = inputValue.value

  getExpandedKey(allLabelList.value)
}

const onExpand = (expanded, record) => {
  if (expanded) {
    expandedKeys.value.push(record.id)
  } else {
    if (expandedKeys.value.length) {
      expandedKeys.value = expandedKeys.value.filter((v) => {
        return v !== record.id
      })
    }
  }
}

const getExpandedKey = (tree: any) => {
  if (tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.name && item.name.indexOf(searchValue.value) > -1)) {
          expandedKeys.value.push(node.id)
        }

        getExpandedKey(node.children)
      }
    }
  }
}

const onStatusClick = (e: any, record?: any) => {
  const p = Object.assign({}, record)
  p.status = record?.status === 0 ? 1 : 0
  p.labelId = record.id
  p.labelName = record.name
  p.sort = record.weight
  updateLabel(p).then(() => {
    message.success('修改状态成功')
    tableRef.value?.fetch()
  })
}

const onDelete = (record?: any) => {
  Modal.delete({
    name: record.name,
    onOk() {
      deleteLabel({
        labelId: record.id
      }).then((res) => {
        message.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

const getParentName: any = (pid: number, list: any) => {
  if (list) {
    for (const child of list) {
      if (child.id === pid) {
        return child
      }
      const foundParent = getParentName(pid, child.children)
      if (foundParent) {
        return foundParent
      }
    }
  }
  return null
}

const onAdd = (record?: any) => {
  labelModalRef.value?.init(null, record)
}

const labelModalRef = ref()
const triggerAddOrEdit = (record?: any) => {
  if (record) {
    record.parentName = getParentName(record.parentId, allLabelList.value)?.name ?? '--'
  }

  labelModalRef.value?.init(record)
}
const allLabelList = ref()

// onMounted(() => {
//   fetch(null, () => {})
// })

const fetch = (q: any, callBack: (res: any) => void) => {
  labelList({ appId: 'cos_lbu' }).then((res) => {
    allLabelList.value = res.data
    callBack(res)
  })
}

const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const labelTypeEnum = [
  {
    value: 0,
    label: '普通标签'
  },
  {
    value: 1,
    label: '特殊标签'
  }
]

const search = () => {
  tableRef.value.search()
}

const columns = computed(() => [
  {
    title: '标签名称',
    dataIndex: 'name'
  },
  {
    title: '类型',
    dataIndex: 'labelType'
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'showDecimalsOrnot' },
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 150
  }
])
</script>

<script lang="ts">
export default { name: 'DcCosLbuLabelManage' }
</script>

<style lang="scss" scoped>
.cos-full-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 0px !important;
}

.full-layout-content {
  display: flex;
  width: 100%;
  flex: 1;
  .left-layout {
    margin-right: 8px;
    flex: initial;
    display: flex;
    padding: 16px 16px 0;
    flex-direction: column;
  }
  .right-layout {
    flex: 1;
    display: flex;
    padding: 16px 16px 0;
    flex-direction: column;
  }
}
.bf {
  background: #fff;
}
</style>
